export default "__VITE_ASSET__Di2_AuYP__"